import {sellerConstants } from '../../_constants/seller.constants';
import swal from 'sweetalert2';

const initialState = { loading : true, data: '', error: false, errorText: ''};

export function addSellerAdmins(state = initialState, action) {
    switch (action.type) {
      case sellerConstants.REQUEST_ADD_SELLER_ADMIN:
        return {
          loading: true,
          data: '',
          error: false,
          errorText: ''
        };
      case sellerConstants.ADD_SELLER_ADMIN_SUCCESS:
      swal({
				text: 'Seller Admin Added Successfully',
				type: 'success',
				confirmButtonColor: '#3085d6',
				confirmButtonText: 'OK'
			})
        return {
          loading: false,
          data: action.data,
          error: false,
          errorText: ''
        };
      case sellerConstants.ADD_SELLER_ADMIN_ERROR:
        return { 
          loading: false,
          data: '',
          error: true,
          errorText: action.error
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/sellers/addSellerAdmin.reducer.js